import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { ToolbarGroup, ToolbarItem } from '@wordpress/components';
/**
 * Internal dependencies
 */

import BlockSettingsDropdown from './block-settings-dropdown';
export function BlockSettingsMenu(_ref) {
  let {
    clientIds,
    ...props
  } = _ref;
  return createElement(ToolbarGroup, null, createElement(ToolbarItem, null, toggleProps => createElement(BlockSettingsDropdown, _extends({
    clientIds: clientIds,
    toggleProps: toggleProps
  }, props))));
}
export default BlockSettingsMenu;
//# sourceMappingURL=index.js.map